module.exports = __webpack_public_path__ + "img/marco.fcc1eb8c.png";